import { useSelector } from "react-redux";

import { InternalButton } from "@sharedComponents/buttons";

import { useAuth0V2 } from "@stadium/services/auth0";
import { useJuneSoEventTracker } from "@stadium/services/june-analytics";

import AuthLogin from "@components/auth/buttons/login";

import { useKitItemsContext } from "@contexts/kit-items";

import { getCountry } from "@selectors/country";

import { DEFAULT_SERVICES, CREATE_BUNDLE, ADD_TO_BUNDLE } from "@constants/june-so";

const DEFAULT_ARR = [];
const DEFAULT_OBJ = {};

const AddToBagKitItem = ({
  product,
  btnClass = "",
  btnParentClass = "",
  isDisabled = false,
  isLoading = false,
  onSuccess = null,
  onAdd = null,
  quantity,
}) => {
  const { trackEvent } = useJuneSoEventTracker({
    services: DEFAULT_SERVICES,
    elementPosition: CREATE_BUNDLE,
  });

  const country = useSelector(getCountry);

  const { isAuthenticated } = useAuth0V2();

  const { selectedCountryKit } = useKitItemsContext();

  const { bundleProducts: kitProducts = DEFAULT_ARR, number: kitNumber } =
    selectedCountryKit || DEFAULT_OBJ;

  const { id, catalogStoreId } = product;

  const disabled = isLoading || isDisabled;

  const addToBag = () => {
    trackEvent({ target: ADD_TO_BUNDLE });

    const { id: productCartId, quantity: qtyInCart = 0 } =
      kitProducts?.find(
        ({ productId, catalogType, collectionId }) =>
          productId == id &&
          catalogType?.toLowerCase() == country?.iso?.toLowerCase() &&
          Number(collectionId) === Number(catalogStoreId),
      ) || {};

    const payload = [
      {
        productId: Number(id),
        quantity: Number(qtyInCart) + Number(quantity),
        catalogType: country?.iso?.toLowerCase(),
        collectionId: Number(catalogStoreId),
        _destroy: false,
        ...(productCartId && { id: productCartId }),
      },
    ];
    if (onAdd) {
      onAdd(payload, kitNumber).then(() => {
        onSuccess();
      });
    }
  };

  if (!isAuthenticated)
    return (
      <AuthLogin className={btnParentClass}>
        <InternalButton styleType="primary">Add to kit</InternalButton>
      </AuthLogin>
    );

  return (
    <div className={btnParentClass}>
      <InternalButton
        onClick={addToBag}
        isLoading={isLoading}
        disabled={disabled}
        styleType="primary"
      >
        Add to kit
      </InternalButton>
    </div>
  );
};

export default AddToBagKitItem;
